import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Login() {
    const redirectTo = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const { login } = useAuth();

    useEffect(() => {
        document.title = 'Music Website | Login';
    }, []);

    const validate = () => {
        const newErrors = {};
        if (!email.trim()) newErrors.email = 'Email feild is required.';
        else if (!email.includes('@')) newErrors.email = 'Please enter a valid email.';

        if (!password.trim()) newErrors.password = 'Password feild is required.';
        else if (password.length < 6) newErrors.password = 'Password must be at least 6 characters.';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleLogin = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        try {            
            await login(email, password);
            redirectTo("/dashboard");
        } catch (error) {
            console.error('Login failed:', error.message);
            alert('Invalid credentials');
        }
    };

    return (
        <section className="section main-section">
            <div className="card">
                <header className="card-header">
                    <p className="card-header-title">
                        <span className="icon"><i className="mdi mdi-lock"></i></span>
                        Login
                    </p>
                </header>
                <div className="card-content">
                    <div className="field spaced">
                        <label className="label">Email <span className="text-error-500">*</span></label>
                        <div className="control icons-left">
                            <input className="input" type="email" name="email" placeholder="user@example.com" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                            <span className="icon is-small left"><i className="mdi mdi-account"></i></span>
                        </div>
                        {errors.email && <p className="help" style={{ color: 'red' }}>{errors.email}</p>}
                    </div>

                    <div className="field spaced">
                        <label className="label">Password <span className="text-error-500">*</span></label>
                        <p className="control icons-left">
                            <input className="input" type="password" name="password" placeholder="Password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
                            <span className="icon is-small left"><i className="mdi mdi-asterisk"></i></span>
                        </p>
                        {errors.password && <p className="help" style={{ color: 'red' }}>{errors.password}</p>}
                    </div>
                    <hr />
                    <div className="field grouped">
                        <div className="control">
                            <button type="submit" className="button blue" onClick={handleLogin}>
                                Login
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    );
};

export default Login;